import { Badge, Button } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const AdvancedSearchButton = ({
  filterCount = 0,
  loading = false,
  onClick = () => {},
}) => {
  return (
    <>
      <Button loading={loading} onClick={onClick} icon={<SettingOutlined />}>
        Advanced Search
        {filterCount > 0 && (
          <Badge
            count={filterCount}
            color="gray"
            style={{ marginLeft: "0.5rem", marginBottom: "0.1rem" }}
          />
        )}
      </Button>
    </>
  );
};

export default AdvancedSearchButton;
